import React from 'react';
import Helmet from 'react-helmet-async';
import { withRouter } from 'react-router-dom';

const SITE_URL = 'https://www.dylanlewis.com';
const DEFAULT_TITLE = 'Dylan Lewis Studio & Sculpture Garden';
const DEFAULT_DESCRIPTION =
  'Dylan is widely recognised as one of the world’s foremost sculptors of the animal form, he initially focused on the big cats; in recent years, he has used the human figure to explore our relationship with our inner wilderness.';

const GARDEN_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'TouristAttraction',
  name: 'Dylan Lewis Sculpture Garden',
  url: `${SITE_URL}/garden`,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Paradyskloof Rd, Paradyskloof',
    addressLocality: 'Stellenbosch',
    postalCode: '7600',
    addressRegion: 'Western Cape',
    addressCountry: 'ZA',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -33.970992,
    longitude: 18.872676,
  },
  hasMap: 'https://maps.app.goo.gl/UDNdmV9ohqvww6r78',
};

export const HeaderMeta = withRouter(({ seo, location }) => {
  const pathname = location ? location.pathname : '';
  const canonical = `${SITE_URL}${pathname}`;

  const title = seo.title || DEFAULT_TITLE;
  const description = seo.metadesc || DEFAULT_DESCRIPTION;
  const ogTitle = seo['opengraph-title'] || title;
  const ogDescription = seo['opengraph-description'] || description;

  const isGarden = pathname.startsWith('/garden');
  const structuredData = isGarden
    ? {
        ...GARDEN_STRUCTURED_DATA,
        description,
        image: seo['opengraph-image'] || undefined,
      }
    : null;

  return (
    <Helmet
      defaultTitle={title}
      link={[{ rel: 'canonical', href: canonical }]}
      script={
        structuredData
          ? [
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify(structuredData),
              },
            ]
          : []
      }
      meta={[
        { name: 'description', content: description },
        { property: 'og:title', content: ogTitle },
        { property: 'og:description', content: ogDescription },
        { property: 'og:url', content: canonical },
        { property: 'og:site_name', content: title },
        { property: 'og:type', content: 'business' },
        { property: 'og:image', content: seo['opengraph-image'] },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: seo['twitter-title'] || ogTitle },
        {
          name: 'twitter:description',
          content: seo['twitter-description'] || ogDescription,
        },
        {
          name: 'twitter:image:src',
          content: seo['twitter-image'] || seo['opengraph-image'],
        },
        // Drop any tag whose content is missing rather than emitting "null".
      ].filter(tag => tag.content)}
      htmlAttributes={{ lang: 'en' }}
    />
  );
});
